export enum DocumentStorageKeys {
    WriteStoredTranscriptionDuration = "WriteStoredTranscriptionDuration",
    DeleteStoredTranscriptionDuration = "DeleteStoredTranscriptionDuration",
    GetStoredTranscriptionCustomPropertyDuration = "GetStoredTranscriptionCustomPropertyDuration",
    FailureReason = "FailureReason"
};